export default "__VITE_ASSET__9129b101__"